import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { catchError, map, take } from 'rxjs/operators';
import { Error, CustomHttpErrorResponse } from '../../../../common/constants/error';
import { NotificationService } from '../../../../common';
import { AssignableCompartmentListService } from './assignable-compartments.service';
import { AssignableCompartmentList } from '../../../../container-components';
import { AssignableCompartmentListInitialState, AssignableCompartmentListLoad } from './assignable-compartments.action';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AssignableCompartmentListStateModel {
  assignableCompartmentLists: AssignableCompartmentList[];
  loaded: boolean;
}

const initialState: AssignableCompartmentListStateModel = {
  assignableCompartmentLists: null,
  loaded: false,
};

@State<AssignableCompartmentListStateModel>({
  name: 'assignableCompartmentLists',
  defaults: initialState,
})
@Injectable()
export class AssignableCompartmentListState {
  constructor(
    private assignableCompartmentListService: AssignableCompartmentListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: AssignableCompartmentListStateModel): AssignableCompartmentListStateModel {
    return state;
  }

  @Selector()
  static getCompartmentList(state: AssignableCompartmentListStateModel): AssignableCompartmentList[] {
    return state.assignableCompartmentLists;
  }

  @Selector()
  static getLoaded(state: AssignableCompartmentListStateModel): boolean {
    return state.loaded;
  }

  @Action(AssignableCompartmentListLoad)
  getAssignableCompartmentList(
    ctx: StateContext<AssignableCompartmentListStateModel>,
    { hubIds }: AssignableCompartmentListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.assignableCompartmentListService.getAssignableCompartmentList(hubIds).pipe(
      take(1),
      map((assignableCompartmentLists: AssignableCompartmentList[]) => {
        ctx.patchState({ assignableCompartmentLists, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AssignableCompartmentListInitialState)
  setInitialState(ctx: StateContext<AssignableCompartmentListInitialState>): void {
    ctx.setState(initialState);
  }
}
